import { Link } from "react-router-dom";
import MarketingLayout from "@/components/public/MarketingLayout";
import PublicBreadcrumb from "@/components/public/PublicBreadcrumb";
import { Button } from "@/components/ui/button";

export default function BillingSuccessPage() {
  return (
    <MarketingLayout>
      <section className="mx-auto max-w-3xl px-5 py-24 text-center md:px-8">
        <div className="rounded-[32px] border border-slate-200 bg-white p-10 shadow-sm">
          <div className="text-left"><PublicBreadcrumb backTo="/pricing" backLabel="Torna ai piani" currentLabel="Pagamento completato" /></div>
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-emerald-700">Pagamento completato</div>
          <h1 className="mt-4 font-display text-5xl font-black text-slate-950">Stripe ha confermato il checkout.</h1>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">Se i segreti Stripe sono configurati correttamente, qui verra mostrato il riepilogo del piano attivo e il reindirizzamento all'area riservata.</p>
          <div className="mt-8 flex justify-center gap-3">
            <Button asChild className="rounded-full bg-[#0f172a] px-6 hover:bg-slate-800"><Link to="/app/billing">Vai al billing</Link></Button>
            <Button asChild variant="outline" className="rounded-full border-slate-300 bg-white px-6"><Link to="/app">Apri la piattaforma</Link></Button>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
